<template>
  <div>
    <div v-if="poster">
      <h3 class="text-center mb-3" v-if="previewMode()">Preview</h3>
      <div class="row" v-if="!previewMode()">
        <div v-if="validation.is_checked === false">
          <div v-if="makeValidation()"></div>
        </div>
        <div class="col"
             v-if="(validation.is_checked === true && validation.status === false)">
          <div class="alert alert-danger">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation-circle']" class="fa-3x mx-auto my-auto"/>
              </div>
              <div class="col-8 d-flex">
                <div class="row my-auto">
                  <div class="col d-flex">
                    <h5 class="my-auto">
                      <Speaker :submission_id="poster.setting_submission_id" area="submit"
                               textkey="submission_not_complete"></Speaker>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col"
             v-if="(validation.is_checked === true && validation.status === true)">
          <div class="alert alert-success">
            <div class="row">
              <div class="col-1 d-flex">
              </div>
              <div class="col-8 d-flex">
                <div class="row my-auto">
                  <div class="col d-flex">
                    <h5 class="my-auto">
                      <Speaker :submission_id="poster.setting_submission_id" area="submit"
                               textkey="submission_complete"></Speaker>
                    </h5>
                  </div>
                  <button type="button" class="btn btn-success" v-if="validation.status === true && processing.submit === false"
                          v-on:click="submit();">
                    {{ wording[0].buttons.submit }}
                    <icon :icon="['fad', 'paper-plane']"/>
                  </button>
                  <ProcessingButton class="mr-auto" v-else-if="processing.submit"></ProcessingButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-print-none" v-if="!previewMode()">
        <!--        <div class="col">-->
        <!--          <button class="btn btn-info btn-sm" v-on:click="$router.push('authors')">-->
        <!--            <icon :icon="['fad', 'backward']"/>&nbsp;{{ wording[0].buttons.back_to }}-->
        <!--            {{ getCurrentPages(poster.setting_submission_id).find(page => page.setting_page_type_id === 2).menu_name }}-->
        <!--          </button>-->
        <!--        </div>-->
      </div>
      <div v-for="(page, index) in getCurrentPages(poster.setting_submission_id)" class="mt-3" v-bind:key="index">
        <!--      Dynamische Formulare-->
        <div class="row" v-if="page.setting_page_type_id === 1 && page.entity">
          <div class="col">
            <entitegenerator :entities="page.entity" :values="poster"
                             :system="{main: 'submission', action: 'submit'}"
                             :models="{}"
                             :error="validation.errors" mode="preview"></entitegenerator>
          </div>
        </div>
        <div class="row d-print-none" v-if="page.setting_page_type_id === 1 && page.entity && previewMode() === false">
          <div class="col">
            <button class="btn btn-info btn-sm" v-on:click="$router.push('dynamic/' + page.id)">
              <icon :icon="['fad', 'backward']"/>&nbsp;{{ wording[0].buttons.back_to }} {{ page.menu_name }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="!previewMode()">
        <div class="col d-flex">
          <router-link
              :to="previousSite(getCurrentPages(poster.setting_submission_id), getCurrentPageByType(this.poster.setting_submission_id,3).id)"
              class="mr-auto btn btn-info" tag="button">
            <icon :icon="['fas', 'angle-left']"/>
            {{ wording[0].buttons.back }}
          </router-link>
          <span class="ml-auto">
            <button type="button" class="btn btn-success"
                    v-if="(validation.is_checked === true && validation.status === true) &&processing.submit === false"
                    v-on:click="submit();">
              {{ wording[0].buttons.submit }}
              <icon :icon="['fad', 'paper-plane']"/>
            </button>
          <ProcessingButton class="mr-auto" v-if="processing.submit"></ProcessingButton>
          </span>
        </div>
      </div>
      <div class="row mt-4" v-else>
        <div class="col d-flex">
          <router-link :to="'/home'"
                       class="mr-auto btn btn-info" tag="button">
            <icon :icon="['fas', 'angle-left']"/>
            {{ wording[0].buttons.back }}
          </router-link>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
import entitegenerator from 'entite-generator';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState([
      'poster', 'validation', 'wording', 'processing', 'settings', 'rulexvalue', "language"
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType', "isOpen"
    ]),
  },
  components: {
    entitegenerator
  },
  methods: {
    previewMode() {
      if (this.isOpen(this.poster.setting_submission_id) === false) {
        return true;
      } else if (this.$route.name === 'preview') {
        return true;
      }
      return false;
    },
    submit() {
      this.processing.submit = true;
      if (this.validation.is_checked === true) {
        this.SUBMIT_POSTER(this.$route.params.id).then((result) => {
          this.$router.push('/home');
          this.processing.submit = false;
        })
      }
    },
    makeValidation() {
      this.validation.is_checked = true;
      this.processing.validation = true;
      this.$store.dispatch('VALIDATE');
      this.processing.validation = false;
    },
    ...mapActions([
      'PUT_SUBMIT', 'VALIDATE', 'PUT_POSTER', 'SUBMIT_POSTER', 'VALIDATE_TARGET'
    ]),
    ...mapMutations([])
  },
  created() {
    this.validation.is_checked = false;
    this.processing.validation = false;
  }
}
</script>
<style lang="css">
/*Vordefinierte CSS Klassen innerhalb der Preview Funktion des EntityGenerator*/
/*Für die Zeile*/
.previewRow {
}

/*Fragen Links*/
.previewKey {
  margin-top: 5px;
}

/*Antworten Rechts*/
.previewValue {
}

</style>
